import { StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { BaseStore } from '../base/base.store';

@Injectable({ providedIn: 'root' })
@StoreConfig({
    name: 'article',
    cache: {
        ttl: 15000
    }
})
export class ArticleStore extends BaseStore {
    constructor() {
        super();
    }
}
